// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BollardPosition\ApiBollardPosition.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Berth, BerthData, BerthOptions } from 'data/models/Berth';
import { Measurement, MeasurementData, MeasurementOptions } from 'data/models/Measurement';

// BollardPositionData is the class that BollardPosition serializes to/from
export interface BollardPositionData {
    Id : number;
	
    Berth : BerthData | null;
    BerthId : number;
	
    CssClass : string | null;
    Description : string | null;
    Footmark : MeasurementData;
}

// BollardPositionOptions is the class which may be passed to the BollardPosition constructor to define optional initial data values
export interface BollardPositionOptions {
    Id : number;
	
    Berth? : BerthOptions | null;
    BerthId? : number;
	
    CssClass? : string | null;
    Description? : string | null;
    Footmark? : MeasurementOptions;
}

export class BollardPosition {
    public Id : DataSignal<number>;
	
    public Berth : DataSignal<Berth | null>;
    public BerthId : DataSignal<number>;
	
    public CssClass : DataSignal<string | null>;
    public Description : DataSignal<string | null>;
    public Footmark : Measurement;

    constructor();
    constructor(data : BollardPositionOptions);
    constructor(data: BollardPositionOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Berth = S.value<Berth | null>(null);
        this.BerthId = jsonableObservable(S.value<number>(data && data.BerthId !== undefined ? data.BerthId : 0));
	    
        this.CssClass = jsonableObservable(S.value<string | null>(data && data.CssClass !== undefined ? data.CssClass : null));
        this.Description = jsonableObservable(S.value<string | null>(data && data.Description !== undefined ? data.Description : null));
        this.Footmark = data && data.Footmark !== undefined ? new Measurement(data.Footmark) : new Measurement();
    }

    static key(obj : BollardPosition) {
        return obj.Id();
    }
    
    static dataKey(obj : BollardPositionOptions) {
        return obj.Id;
    }

    static update(obj : BollardPosition, data : BollardPositionOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.BerthId !== undefined) obj.BerthId(data.BerthId);
	        
            if (data.CssClass !== undefined) obj.CssClass(data.CssClass);
            if (data.Description !== undefined) obj.Description(data.Description);
            if (data.Footmark !== undefined) Measurement.update(obj.Footmark, data.Footmark);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BollardPosition.ts